module.exports = __webpack_public_path__ + "img/27m.bdc6cd82.png";